import React, { memo } from 'react';
import { CircularProgress } from '@material-ui/core';

import useStyles from './useStyles';

const Loader = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress size={16} className={classes.Loader} style={{ height: 'min-content' }} />
      <span className={classes.Loader__text}>saving...</span>
    </div>
  );
};

export default memo(Loader);
